import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import {useSelector} from "react-redux";
import user from "../../assets/img/userbig.png";

const EmployeeCard = ({ employee }) => {
    const login = useSelector((state) => state.manager.employee);

    const isDragAllowed = [86, 1024, 1734,1918].includes(login.user_id);
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: String(employee.id),
        disabled: !isDragAllowed,
    });

    return (
        <div
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            style={{
                transform: transform
                    ? `translate(${transform.x}px, ${transform.y}px)`
                    : undefined,
                background: 'white',
                margin: '8px 0',
                padding: '8px',
                borderRadius: '6px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
        >
            <img className="list-item-img m-0 object-fit-cover" src={employee.image || user} alt=""/> {employee.fullname}
        </div>
    );
};

export default EmployeeCard;
